import EmptyState from "./EmptyState";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import { DashboardRoutesConfig } from "@convin/config/routes.config";
import Error500Svg from "@convin/components/svg/Error500Svg";
import { ReactElement } from "react";
import { useGetDomainConfigQuery } from "@convin/redux/services/domain/domain.service";

const {
    subRoutes: { overall_dashboard },
} = DashboardRoutesConfig["Home"];

const conversationRoute = DashboardRoutesConfig.Conversations;

const Error500State: React.FC<{
    error?: string;
    ButtonComponent?: ReactElement;
}> = ({ ButtonComponent }) => {
    const { data: domainConfig } = useGetDomainConfigQuery();
    const isB2cDomain = domainConfig?.domainType === "b2c";
    return (
        <EmptyState
            Component={<Error500Svg />}
            text="Oh No! Internal Server Error"
            subtext="Uh-oh! Something's not right on our end. Try refreshing the page or check back later."
            ButtonComponent={
                ButtonComponent ?? (
                    <Link
                        to={
                            isB2cDomain && !domainConfig?.isMeetingsDefault
                                ? overall_dashboard.to
                                : conversationRoute.to
                        }
                    >
                        <Button variant="global">Back Home</Button>
                    </Link>
                )
            }
        />
    );
};

export default Error500State;
